<template>
  <div>
    <Form :fnoname="'910.00'" :fnoperiod="'halfyear'" :fnotitle="'Упрощенная декларация для субъектов малого бизнеса'"></Form>
  </div>
</template>

<script>
import Form from "@/components/fno/Form";
export default {
  name: "Form920.00",
  components: {
    Form
  }
}
</script>

<style scoped>

</style>